export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
  },
  {
    title: that.$l('table_label_department_number') || '部门编号',
    field: 'depNo',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
    treeNode: true,
  },
  {
    title: that.$l('table_label_department_name') || '部门名称',
    field: 'depName',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_organization') || '所属机构',
    field: 'orgName',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_State') || '状态',
    width: 80,
    align: 'center',
    headerAlign: 'center',
    slots: {default: 'status'},
  },
]
